import React from 'react'


const About = () => (

    <div className="about">
        about
    </div>
)


export default About